import React, { PropsWithChildren, useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import clsx from "clsx";

import { Theme } from "src/theme";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flex: 1,
    padding: "0 30px",
    backgroundColor: "transparent",
    position: "relative",
    marginBottom: 88,
  },
}));

function Wrapper({
  className,
  children,
  ...props
}: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  const classes = useStyles();
  const [fadeIn, setFadeIn] = useState(false);
  const mountedRef = useRef(false);

  useEffect(() => {
    // Fade in on mount
    if (!mountedRef.current) {
      mountedRef.current = true;
      const timer = setTimeout(() => setFadeIn(true), 50);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <main className={clsx(className, classes.root)} {...props}>
      <Fade in={fadeIn} timeout={300}>
        <div>{children}</div>
      </Fade>
    </main>
  );
}

export default Wrapper;
